import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react';
import DataGrid, { Column } from "devextreme-react/ui/data-grid";
import LoadingGif from "../../../../../images/animacion2[18].gif";
import validaciones from "../../../../../helpers/validaciones";
import SelectField from "../../../../Shared/fields/SelectField";
import DateField from "../../../../Shared/fields/DateField";
import CustomStore from 'devextreme/data/custom_store';
import moment from "moment"

import {loadCalendarByDateRange, loadRefreshDataSelected, loadDatingHorizon} from "../actions";

class nuevaGestionColumnaDer extends React.Component {
  constructor(props) {
    super(props);
    const {
      Pools,
      PsychologicalExams,
    } = props.selectedSolicitud
    const firstPool = Pools && Pools.length > 0 && Pools[0]
    const firstCiel = PsychologicalExams && PsychologicalExams.length > 0 && PsychologicalExams[0]
    const achsOffice = firstPool ? firstPool : (firstCiel ? firstCiel : null);
    this.state = {
      days: [],
      idCentro: achsOffice && achsOffice.AchsOfficeId,
      centroList: achsOffice && [achsOffice],
      firstPool: firstPool,
      firstCiel: firstCiel,
      dateSelected: moment().startOf('day').format(),
      year: moment().year(),
      month: moment().month(),
      datePrevSelected: moment().add(-1, "day").startOf('day').format(),
      dateNextSelected: moment().add(1, "day").startOf('day').format(),
      dataSource: null,
      listaHorizonte: []
    };
  }

  componentDidMount = () =>{
    this.props.dispatch(loadCalendarByDateRange(this.state.idCentro, this.state.datePrevSelected, this.state.dateNextSelected));
    this.props.dispatch(loadDatingHorizon(this.state.idCentro, this.state.year, this.state.month + 1));
  }

  componentWillUnmount = () => {
    if(this.props.connectionHub)
      this.props.connectionHub.off('schedulingReceived')
  }

  componentDidUpdate = (prevData) => {
    if(prevData.listaHorizonteCitas !== this.props.listaHorizonteCitas){
      this.setState({ listaHorizonte: this.props.listaHorizonteCitas });
    }
    if(prevData.dataGridCupos !== this.props.dataGridCupos && this.props.connectionHub){
      var store = new CustomStore({
        load: () => this.props.dataGridCupos,
        key: 'StartTime'
      });
      this.props.connectionHub.off('schedulingReceived')
      this.props.connectionHub.on('schedulingReceived',(data) => {
        if(data.OfficeId === this.state.idCentro && moment(data.Date).isBetween(moment(this.state.datePrevSelected), moment(this.state.dateNextSelected), null, '[]')){
          if(data.IsDelete && data.IsRefreshAll){
            if(this.props.userData.RUT === data.Rut.replace(".", "")){
              this.props.close()
            }else{
              this.props.dispatch(loadCalendarByDateRange(this.state.idCentro, this.state.datePrevSelected, this.state.dateNextSelected, this.props.selectedSolicitud.Id))
            }
          }else if(data.IsRefreshAll){
            this.props.dispatch(loadCalendarByDateRange(this.state.idCentro, this.state.datePrevSelected, this.state.dateNextSelected, this.props.selectedSolicitud.Id))
          } else if(data.IsReserve || data.IsDelete){
            var _key = this.props.dataGridCupos.find(e => e.EndTime === data.EndTime && e.StartTime === data.StartTime);
            if(_key){
              var _date = _key.Days.find(e => moment(e.Date).startOf('day').isSame(moment(data.Date).startOf('day')) )
              if(_date && _date.TypeQuotaModule && _date.TypeQuotaModule.length && data.TypeQuotaScheduling){
                _date.TypeQuotaModule = data.TypeQuotaScheduling;
                _key.Days = _key.Days.map(e => {
                  if(moment(e.Date).startOf('day').isSame(moment(_date.Date).startOf('day'))){
                    return _date;
                  }else{
                    return e;
                  }
                })
                store.push([{ type: 'update', key: _key.StartTime, data: _key }]);
                let _rut1 = this.props.userData.RUT;
                let _rut2 = data.Rut.replace(".", "")
                if(_rut1 === _rut2){
                  this.props.dispatch(loadRefreshDataSelected(this.props.selectedSolicitud.Id))
                }

              }
            }
            this.setState({dataSource: store})
          }
        }
      });
      this.setState({dataSource: store})
    }
  }

  handleChangeDate = (e) => {
    if(this.props.isLoading) return false;
    this.setState({
      dateSelected: moment(e.value).startOf('day').format(),
      datePrevSelected: moment(e.value).add(-1, "day").startOf('day').format(),
      dateNextSelected: moment(e.value).add(1, "day").startOf('day').format()
    }, () => {
      if(this.state.idCentro)
        this.props.dispatch(loadCalendarByDateRange(this.state.idCentro, this.state.datePrevSelected, this.state.dateNextSelected))
    })
  }

  handleNextDay = (e) => {
    if(this.props.isLoading) return false;
    let _date = this.state.dateSelected
    this.setState({
      dateSelected: moment(_date).add(1, "day").startOf('day').format(),
      datePrevSelected: moment(_date).startOf('day').format(),
      dateNextSelected: moment(_date).add(2, "day").startOf('day').format()
    }, () => {
      if(this.state.idCentro)
        this.props.dispatch(loadCalendarByDateRange(this.state.idCentro, this.state.datePrevSelected, this.state.dateNextSelected))
    })
  }

  handlePrevDay = (e) => {
    if(this.props.isLoading) return false;
    let _date = this.state.dateSelected
    this.setState({
      dateSelected: moment(_date).add(-1, "day").startOf('day').format(),
      datePrevSelected: moment(_date).add(-2, "day").startOf('day').format(),
      dateNextSelected: moment(_date).startOf('day').format()
    }, () => {
      if(this.state.idCentro)
        this.props.dispatch(loadCalendarByDateRange(this.state.idCentro, this.state.datePrevSelected, this.state.dateNextSelected))
    })
  }

  handleChangeCity = (e) => {
    if(this.props.isLoading) return false;
    this.setState({
      idCentro: e.value
    }, () => {
      if(this.state.idCentro)
        this.props.dispatch(loadCalendarByDateRange(this.state.idCentro, this.state.datePrevSelected, this.state.dateNextSelected))
    })
  }

  getTypeButton = (typeButton, text, _nameClass, data, date, typeAmount) => {
    return <Button
      focusStateEnabled={false}
      hoverStateEnabled={false}
      className={_nameClass}
      height={35}
      width={120}
      text={text}
      type={"success"}
      stylingMode={typeButton}
      onClick={e => this.props.onSchedulingSelected(data, this.state.idCentro, date, typeAmount)}
    />
  }

  onInitialized = (e) =>{
    e.component.option("calendarOptions",
    {
      cellTemplate: (itemData, itemIndex, itemElement) => {
        let horizonDate = this.state.listaHorizonte;
        let itemDataMonth = moment(itemData.date).format('MM');
        var myCustomMarkup = "";
        myCustomMarkup = "<div>" + itemData.text + "</div><span style='color: #f5f5f5'>●</span><span style='color: #f5f5f5'>●</span>";
        if (itemData && itemData.text && horizonDate && horizonDate.DatingDate && horizonDate.DatingDate.length > 0){
          horizonDate.DatingDate.map(item => {
            var horizonDay = moment(item.DateScheduling).format('DD');
            var horizonMonth = moment(item.DateScheduling).format('MM');
            if(itemDataMonth === horizonMonth){
              if(itemData.text.toString() === horizonDay){
                if(item.QuotaAvailable === true && item.QuotaId === 1){
                  myCustomMarkup = "<div>" + itemData.text + "</div><span style='color: #007f79'>●</span><span style='color: #f5f5f5'>●</span>";
                }
                if(item.QuotaAvailable === true && item.QuotaId === 41){
                  myCustomMarkup = "<div>" + itemData.text + "</div><span style='color: #f5f5f5'>●</span><span style='color: #CCA700'>●</span>";
                }
                if(item.QuotaAvailable === true && item.QuotaId === 43){
                  myCustomMarkup = "<div>" + itemData.text + "</div><span style='color: #007f79'>●</span><span style='color: #CCA700'>●</span>";
                }
              }
            }
          })
        }
        return myCustomMarkup;
      },
      elementAttr: { class: "horizonteCitasPopup" }
    })
  }

  cellRender = (dataCell, date) => {
    if(!dataCell.Days) return "";
    const _data = dataCell.Days.find(e => moment(e.Date).isSame(moment(date)))
    if(!_data) return "";
    let _quotaSep = _data.TypeQuotaModule.find(e => e.QuotaId === this.props.selectedSolicitud.RequestTypeId) // Preocupacional u Ocupacional
    let _quotaCiel = _data.TypeQuotaModule.find(e => e.QuotaId === 41) // Ciel
    _quotaSep.StartTime = dataCell.StartTime
    _quotaSep.EndTime = dataCell.EndTime
    _quotaCiel.StartTime = dataCell.StartTime
    _quotaCiel.EndTime = dataCell.EndTime
    const _buttons = <React.Fragment>
      <div className="row buttonContainer">
        <div className="col-6">
          {
            this.state.firstPool && _quotaSep ?
              _quotaSep.AmmountQuotaAvailable ? this.getTypeButton("contained", _quotaSep.AmmountQuotaAvailable +" cupo", "sep", _quotaSep, date, 1)
              : _quotaSep.AmmountOverQuotaAvailable ? this.getTypeButton("outlined", _quotaSep.AmmountOverQuotaAvailable + " sobrecupos", "sepOutlined", _quotaSep, date, 2)
                : ""
            : ""
          }
        </div>
        <div className="col-6">
          {
            this.state.firstCiel && _quotaCiel ?
            _quotaCiel.AmmountQuotaAvailable ? this.getTypeButton("contained", _quotaCiel.AmmountQuotaAvailable +" cupo", "ciel", _quotaCiel, date, 1)
              : _quotaCiel.AmmountOverQuotaAvailable ? this.getTypeButton("outlined", _quotaCiel.AmmountOverQuotaAvailable + " sobrecupos", "cielOutlined", _quotaCiel, date, 2)
                : ""
            :""
          }
        </div>
      </div>
    </React.Fragment>
    return _buttons
  }

  render() {
    const horizonDate = this.props.listaHorizonteCitas;
    return (
      <React.Fragment>
        <div className="row justify-content-md-center">
          <div className="col-5">
            <SelectField
              displayExpr="AchsOfficeDescription"
              valueExpr="AchsOfficeId"
              dataSource={this.state.centroList}
              id="centro"
              disabled
              //onValueChanged={this.handleChangeCity}
              value={this.state.idCentro}
            />
          </div>
          <div className="col-5">
            <DateField
              max={null}
              styleRoot={{ marginTop: 0 }}
              id="fecha"
              onChange={this.handleChangeDate}
              type="date"
              value={this.state.dateSelected}
              onInitialized={this.onInitialized}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-1 buttonContent">
            <Button className={"buttonPrev"} icon={'chevronprev'} onClick={e=>this.handlePrevDay()}/>
          </div>
          <div className="col-10">
            <DataGrid
              height= {"71vh"}
              repaintChangesOnly={true}
              highlightChanges={true}
              dataSource={this.state.dataSource || []}
              showColumnLines= {false}
              showRowLines= {true}
              rowAlternationEnabled= {true}
              showBorders= {true}
              noDataText=""
              className="custom-table nuevaGestion"
              hoverStateEnabled={false}
              activeStateEnabled={false}
              focusStateEnabled={false}
              onContentReady={(e) => {
                if (e.component.totalCount() === 0) {
                  const config = {};
                  config.addClass = "table-margin";
                  const noDataSpan = e.component.element().querySelector(".dx-datagrid-nodata");
                  const element = validaciones.noDataDOMElement(config, "No hay cupos");
                  noDataSpan.appendChild(element);
                }
              }}

              loadPanel={{
                enabled: false,
                showPane: true,
                showIndicator: true,
                indicatorSrc: LoadingGif,
                text: "Cargando...",
              }}
              paging={{
                pageSize: 48,
              }}
              pager={{
                showInfo: false,
                visible: false,
              }}
            >
              <Column
                headerCellTemplate={(element, row) => ReactDOM.render(<div></div>, element)}
                cellRender={(props) => <div>{props.data.StartTime} - {props.data.EndTime}</div>}
              />
              <Column
                headerCellTemplate={(element, row) => ReactDOM.render(<div style={{textTransform: "capitalize"}}>{moment(this.state.datePrevSelected).format("dddd DD")}</div>, element)}
                cellRender={(data) => this.cellRender(data.data, this.state.datePrevSelected)}
              />
              <Column
                headerCellTemplate={(element, row) => ReactDOM.render(<div style={{textTransform: "capitalize"}}>{moment(this.state.dateSelected).format("dddd DD")}</div>, element)}
                cellRender={(data) => this.cellRender(data.data, this.state.dateSelected)}
              />
              <Column
                headerCellTemplate={(element, row) => ReactDOM.render(<div style={{textTransform: "capitalize"}}>{moment(this.state.dateNextSelected).format("dddd DD")}</div>, element)}
                cellRender={(data) => this.cellRender(data.data, this.state.dateNextSelected)}
              />
            </DataGrid>
          </div>
          <div className="col-1 buttonContent">
            <Button className={"buttonNext"} icon={'chevronright'} onClick={e=> this.handleNextDay()}/>
          </div>
        </div>
      </React.Fragment>
    );
  }
}


const mapStateToProps = (state) => ({
  isLoading: state.inboxSolicitudes.isLoading,
  companyId: state.global.companyId,
  sucursalId: state.global.sucursalId,
  userData: state.global.userData,
  selectedSolicitud: state.inboxSolicitudes.selectedSolicitud,
  dataGridCupos: state.inboxSolicitudes.dataGridCupos,
  hourRange: state.inboxSolicitudes.hourRange,
  listaHorizonteCitas: state.inboxSolicitudes.listaHorizonteCitas
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(nuevaGestionColumnaDer);

